"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = exports.Track = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Track = _styledComponents["default"].div.withConfig({
  displayName: "styled__Track",
  componentId: "yk7grp-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n    min-width: 100%;\n    display: block;\n    overflow: hidden;\n    white-space: nowrap;\n    cursor: grab;\n"])));

exports.Track = Track;

var List = _styledComponents["default"].div.withConfig({
  displayName: "styled__List",
  componentId: "yk7grp-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: nowrap;\n    transition: transform 0.2s linear;\n"])));

exports.List = List;